import Types from "../actionTypes"
import { fromJS } from "immutable"

const INITIAL_STATE = fromJS({
	data: {},
	currentTabRegNo: null,
	contentHeight: 0,
	soModalVisable: false,
	soModalEditing: false,
	soModalLoading: false,
	regNoInputValue: null,
	soNoTextAreaValue: null,
	soModalMessage: null,
	queryLoading: false,
	contModalVisable: false,
	contModalList: [],
})

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case Types.UPDATE_CONTENT_HEIGHT: {
			return state.set("contentHeight", action.payload)
		}
		case Types.UPDATE_CURRENT_REGNO: {
			return state.set("currentTabRegNo", action.payload)
		}
		case Types.UPDATE_DATA: {
			return state.set("data", fromJS(action.payload))
		}
		case Types.SHOW_SO_MODAL: {
			return state
				.set("soModalVisable", true)
				.set("soModalEditing", false)
				.set("regNoInputValue", null)
				.set("soNoTextAreaValue", null)
				.set("soModalMessage", null)
				.set("soModalLoading", false)
		}
		case Types.SHOW_SO_EDIT_MODAL: {
			return state
				.set("soModalVisable", true)
				.set("soModalEditing", true)
				.set("regNoInputValue", action.payload.regNo)
				.set("soNoTextAreaValue", action.payload.soNos)
				.set("soModalMessage", null)
				.set("soModalLoading", false)
		}
		case Types.HIDE_SO_MODAL: {
			return state
				.set("soModalVisable", false)
				.set("soModalLoading", false)
		}
		case Types.START_SO_MODAL_LOADING: {
			return state.set("soModalLoading", true)
		}
		case Types.STOP_SO_MODAL_LOADING: {
			return state.set("soModalLoading", false)
		}
		case Types.SHOW_CONT_MODAL: {
			return state
				.set("contModalVisable", true)
				.set("contModalList", fromJS(action.payload))
		}
		case Types.HIDE_CONT_MODAL: {
			return state
				.set("contModalVisable", false)
				.set("contModalList", fromJS([]))
		}
		case Types.UPDATE_REG_NO_INPUT: {
			return state.set("regNoInputValue", action.payload)
		}
		case Types.UPDATE_SO_NO_TEXTAREA: {
			return state.set("soNoTextAreaValue", action.payload)
		}
		case Types.UPDATE_SO_MODAL_MESSAGE: {
			return state
				.set("soModalMessage", action.payload)
				.set("soModalLoading", false)
		}
		case Types.START_QUERY_LOADING: {
			return state.set("queryLoading", true)
		}
		case Types.STOP_QUERY_LOADING: {
			return state.set("queryLoading", false)
		}
		case Types.UPDATE_REG_DATA: {
			return state.setIn(["data", action.payload.regNo], fromJS(action.payload.data))
		}
		case Types.REMOVE_REG: {
			return state.deleteIn(["data", action.payload])
		}
		default: {
			return state
		}
	}
}



// WEBPACK FOOTER //
// ./src/redux/main/reducer.js